import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Main from './Main';
import './styles/design-tokens.css';
import './styles/modern-overrides.css';


window.rootContent = document.getElementById('root');
ReactDOM.render((<BrowserRouter basename={window.contextPath}>
  <Main />
</BrowserRouter>), window.rootContent);

//TODO
//Check if there is a authToken in localstorage, else load login
//Ajax call to get user account
//  On failure , load Login
//  On success, 
//    Check users last projectID
//      if null, load projects page
//      if not null, load project management page




// WEBPACK FOOTER //
// ./src/index.js